<div class="formula-bar-container">
  <va-formula-bar
    *ngIf="isReady"
    [dpCallObj]="dpCallObj"
    apiUrl="/api/get_fb"
    [apiEP]="apiEP"
  ></va-formula-bar>
</div>
